export default __webpack_public_path__ + "static/media/create_site_in_app.e3174d2a.png";